// api根路径
export const API_ROOT = process.env.API_ROOT



// WEBPACK FOOTER //
// ./src/util/config.js